import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { LoadingService } from '@app/core'
import { NotificationService } from '@app/core/services/notification.service'
import { Observable } from 'rxjs'
import { LostPasswordService } from '@app/session/services/lost-password.service'

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LostPasswordComponent {
  form: FormGroup<{ email: FormControl<string> }>

  isLoading$: Observable<boolean>

  constructor(
    private lostPasswordService: LostPasswordService,
    private router: Router,
    private notificationService: NotificationService,
    loadingService: LoadingService,
    formBuilder: FormBuilder,
  ) {
    this.isLoading$ = loadingService.isLoading$

    this.form = formBuilder.group({
      email: ['', Validators.email],
    })
  }

  get email(): AbstractControl {
    return this.form.get('email')
  }

  onSubmit(form): void {
    this.lostPasswordService.recoverPassword(form.email)

    this.notificationService.success('UI.ResetPassword.Message.MailSendSuccess', null, { duration: 30000 })
    this.router.navigateByUrl('/login')
  }
}
